<template>
  <div class="independent-wrapper">
    <div class="content">
      <div class="title">
        <span class="border"></span>
        <i class="el-icon-location-outline"></i> 商城管理 > 退款管理
      </div>
      <div class="contentLeft">
        <div class="con">
          <div class="toolbar">
            <el-input v-model="query.refundNo" placeholder="退款单号" clearable style="width: 200px; margin-right: 10px;" @keyup.enter="handleSearch"></el-input>
            <el-input v-model="query.orderNo" placeholder="订单号" clearable style="width: 200px; margin-right: 10px;" @keyup.enter="handleSearch"></el-input>
            <el-select v-model="query.status" placeholder="全部状态" clearable style="width: 130px; margin-right: 10px;" @change="handleSearch">
              <el-option label="待处理" :value="0"></el-option>
              <el-option label="部分成功" :value="1"></el-option>
              <el-option label="全部成功" :value="2"></el-option>
              <el-option label="失败" :value="3"></el-option>
            </el-select>
            <el-button type="primary" @click="handleSearch">查询</el-button>
          </div>

          <div class="table-con consiliaTable">
            <el-table
              :header-cell-style="{ background: '#f7f7f7', color: '#333' }"
              tooltip-effect="dark"
              style="width: 100%"
              :data="tableData"
              v-loading="loading"
            >
              <el-table-column align="center" label="退款单号" prop="refundNo" min-width="220"></el-table-column>
              <el-table-column align="center" label="订单号" prop="orderNo" width="180"></el-table-column>
              <el-table-column align="center" label="会员" width="120">
                <template #default="{ row }">
                  <div>{{ row.memberName || '-' }}</div>
                  <div style="font-size: 12px; color: #999;">{{ row.memberPhone }}</div>
                </template>
              </el-table-column>
              <el-table-column align="center" label="退款金额" width="110">
                <template #default="{ row }">
                  <span style="color: #f56c6c; font-weight: bold;">¥{{ formatPrice(row.refundAmount) }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="余额返还" width="100">
                <template #default="{ row }">¥{{ formatPrice(row.refundBalance) }}</template>
              </el-table-column>
              <el-table-column align="center" label="微信退款" width="100">
                <template #default="{ row }">¥{{ formatPrice(row.refundWxpay) }}</template>
              </el-table-column>
              <el-table-column align="center" label="状态" width="100">
                <template #default="{ row }">
                  <el-tag :type="statusTagType(row.status)" size="small">{{ row.statusName }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column align="center" label="原因" prop="reason" min-width="160" show-overflow-tooltip></el-table-column>
              <el-table-column align="center" label="创建时间" width="160">
                <template #default="{ row }">{{ formatTime(row.createTime) }}</template>
              </el-table-column>
              <el-table-column align="center" label="完成时间" width="160">
                <template #default="{ row }">{{ formatTime(row.finishTime) }}</template>
              </el-table-column>
            </el-table>

            <div class="pagination-wrap">
              <el-pagination
                background
                layout="total, prev, pager, next"
                :total="total"
                :current-page="query.pageNum"
                :page-size="query.pageSize"
                @current-change="handlePageChange"
              ></el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axiosconf from '../../api/axiosconf'

export default {
  data() {
    return {
      loading: false,
      tableData: [],
      total: 0,
      query: {
        pageNum: 1,
        pageSize: 10,
        refundNo: '',
        orderNo: '',
        status: null,
      },
    }
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    formatPrice(val) {
      if (val === null || val === undefined) return '0.00'
      return parseFloat(val).toFixed(2)
    },
    formatTime(val) {
      if (!val) return '-'
      if (typeof val === 'string') return val
      return new Date(val).toLocaleString('zh-CN', { hour12: false })
    },
    statusTagType(status) {
      const map = { 0: 'info', 1: 'warning', 2: 'success', 3: 'danger' }
      return map[status] || 'info'
    },
    handleSearch() {
      this.query.pageNum = 1
      this.fetchList()
    },
    async fetchList() {
      this.loading = true
      try {
        const params = {
          pageNum: this.query.pageNum,
          pageSize: this.query.pageSize,
        }
        if (this.query.refundNo) params.refundNo = this.query.refundNo
        if (this.query.orderNo) params.orderNo = this.query.orderNo
        if (this.query.status !== null && this.query.status !== '') params.status = this.query.status
        const res = await axiosconf.applicationJson('/mall/admin/refund/list', params)
        if (res.data && res.data.code === 0) {
          this.tableData = res.data.data.records || []
          this.total = res.data.data.total || 0
        }
      } catch (e) {
        console.error('获取退款列表失败', e)
      } finally {
        this.loading = false
      }
    },
    handlePageChange(page) {
      this.query.pageNum = page
      this.fetchList()
    },
  },
}
</script>

<style scoped>
.independent-wrapper { width: 100%; height: 100%; overflow-y: auto; }
.content { padding: 20px; }
.title { font-size: 14px; color: #333; margin-bottom: 20px; }
.title .border { display: inline-block; width: 3px; height: 14px; background: #679FF6; margin-right: 8px; vertical-align: middle; }
.toolbar { margin-bottom: 16px; display: flex; align-items: center; }
.pagination-wrap { margin-top: 16px; text-align: right; }
</style>
